import { mediaQueries, Theme } from "@ugc-ui/lego";
import styled from "@emotion/styled";

export const ModalContentWrapperStyled = styled.div<{
  theme: Theme;
  fullScreen: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-height: ${({ fullScreen }) =>
    fullScreen ? "calc(var(--vh, 1vh) * 100)" : "auto"};

  background-color: ${({ theme, fullScreen }) =>
    fullScreen ? "#1b1b1f" : theme.background["02"]};
  border-radius: ${({ fullScreen }) => (fullScreen ? "none" : "16px")};

  ${mediaQueries.lg} {
    margin: ${({ fullScreen }) => (fullScreen ? "none" : "0 24px")};
    padding: 16px;
  }
`;
